import { ControlPanel } from "./ControlPanel";
import DisplayPanel from "./DisplayPanel";
import Lift from "./Lift";
import Shaft from "./Shaft";
import Building from "./Building";

export default Object.assign(Building, {
  ControlPanel,
  DisplayPanel,
  Lift,
  Shaft,
});
